module.exports = __webpack_public_path__ + "img/62_2.4ec93fa3.png";